import { ReactElement } from 'react';

interface SiteVisitRecordingDurationReminderModalProps {
	readonly onStop: () => void;
	readonly onContinue: () => void;
}

/** Reminder at 45 min: stop now (Yes) or continue until the 1 hr hard limit (No). */
export function SiteVisitRecordingDurationReminderModal({
	onStop,
	onContinue,
}: Readonly<SiteVisitRecordingDurationReminderModalProps>): ReactElement {
	return (
		<div className="conform-pop">
			<span className="h4">
				Still recording?, do you want to stop it or continue? The recording will be hard stopped on 1 hour.
			</span>

			<div className="button-component">
				<button className="btn btn-primary btn-primary-2" type="button" onClick={onContinue}>
					Continue
				</button>

				<button className="btn btn-primary" type="button" onClick={onStop}>
					Stop
				</button>
			</div>
		</div>
	);
}
